import MainComponent from "components/Main";

import Input from "components/Input";
import ButtonIconSelect from "components/ButtonIconSelect";

import { ReactComponent as DragIcon } from 'icons/components/drag.svg';
import { ReactComponent as CloseIcon } from 'icons/components/bufferClose.svg';
import { ReactComponent as CheckIcon } from 'icons/components/check.svg';
import { ReactComponent as ArrowIcon } from 'icons/components/arrow.svg';
import { ReactComponent as MakePositionIcon } from 'icons/components/makePosition.svg';
import { ReactComponent as ArrowRightSIcon } from 'icons/components/arrowRightS.svg';

import '../index.less';
import '../themes/default.less';

export default class Category extends MainComponent {

    constructor(props) {
        super(props);

        this.priceNodes = {};

        this.state = {
            ...this.state,
            editName: "",
            editRow: false,
            openCat: false,
        };
    }

    onEnableDrag(id, e) {
        e.stopPropagation();
        this[`subItem${id}`].setAttribute('draggable', 'true');
        this._helper.on(this[`subItem${id}`], "dragstart", () => {
            this._helper.dom.addClass(this[`subItem${id}`], "dragging");
        });

        this._helper.on(this[`subItem${id}`], "dragend", () => {
            this._helper.dom.removeClass(this[`subItem${id}`], "dragging");
            this.props.info.dragend();
        });

    }

    onDisableDrag(id) {
        this[`subItem${id}`].setAttribute('draggable', 'false');
    }

    toggleEditRow(event, mode, name) {
        if (event === "+") {
            const editRow = mode;
            const editName = name;

            this.setState({ editRow, editName });
        } else
            this.changeState("editRow", false);

    }

    togglePriceItem() {
        this.toggleState("openCat");
        //setTimeout(this.checkScroll, 200);
    }

    renderDragButt(source, id) {
        return (<div
            className="drag move"
            onMouseDown={this.onEnableDrag.bind(this, id)}
            onMouseUp={this.onDisableDrag.bind(this, id)}
        >
            <DragIcon />
        </div>);
    }

    saveValue(info) {
        const { editRow, editName } = this.state;
        this.props.info.saveChange({ ...info, editName }, editRow);
        this.toggleEditRow("-");
    }

    renderEditButton(info, editRow) {
        return (<div className="buttEdit flex">
            <div className="flex1 flex centerH centerV hand" onClick={this.toggleEditRow.bind(this, "-")}><CloseIcon /></div>
            <div className="flex1 flex centerH centerV hand" onClick={this.saveValue.bind(this, info)}><CheckIcon /></div>
        </div>);
    }

    render() {
        const { editRow, editName, openCat } = this.state;
        const { id: origId, name, tempId, modePrice, renderPriceCat, items, parentItem } = this.props.info;
        const id = origId || tempId;

        const itemsContext = [
            { name: "main.edit", onClick: this.toggleEditRow.bind(this, "+", id, name) },
            { name: "client.delete", onClick: null },
            { line: true },
            { name: "price.moveStart", icon: <ArrowRightSIcon className="icon rotate90m" />, onClick: null },
            { name: "price.moveEnd", icon: <ArrowRightSIcon className="icon rotate90" />, onClick: null },
        ];

        if (items.length < 1) {
            itemsContext.splice(4, 0, { name: "price.convertPos", icon: <MakePositionIcon />, onClick: null });
            itemsContext.splice(5, 0, { line: true });
        }

        return (
            <div key={"pricecat" + id} ref={el => this.priceNodes[id] = el} className="item flex col">
                <div className={`subItems ${modePrice === "edit" ? "edit" : ""} transit025 ${openCat ? "active" : ""}`}>
                    <div
                        className={`subItem flex gap16 hand`}
                        onClick={editRow ? null : this.togglePriceItem.bind(this)}>
                        <div
                            className="flex flex1 gap8 centerV  gap8"
                        >
                            {modePrice === "edit" && !editRow && this.renderDragButt("item")}
                            <ArrowIcon className={`icon  ${openCat ? "rotate90" : "rotate90m"}`} />
                            {editRow ? <div className="inpname flex1">
                                <Input value={editName} onChange={this.changeState.bind(this, "editName")} />
                            </div> :
                                <div className="nameCat text p1SemiBold">{name}</div>}
                        </div>
                        {modePrice === "edit" && (editRow ? this.renderEditButton(this.props.info, editRow) : <ButtonIconSelect
                            translate={true}
                            stopEvent={true}
                            items={itemsContext}
                        />)}
                    </div>
                    {items.map((subIt, key2) => renderPriceCat(subIt, key2, parentItem))}
                </div>
            </div>
        );
    }
}
